import type { Locale } from './game/types';

export const localeNames: Record<Locale, string> = { de: 'Deutsch', en: 'English', fr: 'Français', es: 'Español', it: 'Italiano' };

const dictionary = {
  play: ['Spielen','Play','Jouer','Jugar','Gioca'],
  endless: ['Endlosmodus','Endless mode','Mode infini','Modo infinito','Modalità infinita'],
  settings: ['Einstellungen','Settings','Paramètres','Ajustes','Impostazioni'],
  quit: ['Spiel beenden','Quit game','Quitter le jeu','Salir del juego','Esci dal gioco'],
  profile: ['Profil','Profile','Profil','Perfil','Profilo'],
  friends: ['Freunde','Friends','Amis','Amigos','Amici'],
  shop: ['Sternenmarkt','Star market','Marché stellaire','Mercado estelar','Mercato stellare'],
  campaign: ['Kampagne','Campaign','Campagne','Campaña','Campagna'],
  back: ['Zurück','Back','Retour','Volver','Indietro'],
  continue: ['Weiter','Continue','Continuer','Continuar','Continua'],
  start: ['Mission starten','Start mission','Lancer la mission','Iniciar misión','Avvia missione'],
  locked: ['Gesperrt','Locked','Verrouillé','Bloqueado','Bloccato'],
  score: ['Punkte','Score','Score','Puntos','Punti'],
  moves: ['Züge','Moves','Coups','Movimientos','Mosse'],
  time: ['Zeit','Time','Temps','Tiempo','Tempo'],
  story: ['Bordbuch','Logbook','Journal de bord','Bitácora','Diario di bordo'],
  audio: ['Audio','Audio','Audio','Audio','Audio'],
  display: ['Darstellung','Display','Affichage','Pantalla','Schermo'],
  language: ['Sprache','Language','Langue','Idioma','Lingua'],
  privacy: ['Datenschutz','Privacy','Confidentialité','Privacidad','Privacy'],
  masterVolume: ['Gesamtlautstärke','Master volume','Volume général','Volumen general','Volume generale'],
  music: ['Musik','Music','Musique','Música','Musica'],
  effects: ['Effekte','Effects','Effets','Efectos','Effetti'],
  reducedMotion: ['Bewegung reduzieren','Reduce motion','Réduire les animations','Reducir movimiento','Riduci movimento'],
  fastAnimations: ['Schnelle Animationen','Fast animations','Animations rapides','Animaciones rápidas','Animazioni rapide'],
  highContrast: ['Hoher Kontrast','High contrast','Contraste élevé','Alto contraste','Contrasto elevato'],
  legal: ['Rechtliches','Legal','Mentions légales','Legal','Note legali'],
  completed: ['Abgeschlossen','Completed','Terminé','Completado','Completato'],
  weekly: ['Wochenrangliste','Weekly ranking','Classement hebdomadaire','Clasificación semanal','Classifica settimanale'],
  noFriends: ['Noch keine Crew-Freunde. Teile deinen Freundescode.','No crew friends yet. Share your friend code.','Aucun ami pour le moment. Partage ton code.','Aún no hay amigos. Comparte tu código.','Ancora nessun amico. Condividi il tuo codice.'],
  save: ['Speichern','Save','Enregistrer','Guardar','Salva'],
  install: ['App installieren','Install app','Installer l’app','Instalar aplicación','Installa app'],
} as const;

type Key = keyof typeof dictionary;
const localeIndex: Record<Locale, number> = { de:0, en:1, fr:2, es:3, it:4 };
export const tr = (locale: Locale, key: Key): string => dictionary[key][localeIndex[locale]];
